{
  "formGeneralDescription": "Questo modulo permette di configurare il connettore PKI; al momento solo i PKI Microsoft sono supportati da LX CONNECT.",
  "formRootCaDescription": "La RootCA deve avere il formato .PEM e deve pesare meno di 1 MB.",
  "validation": {
    "url": "L’URL del server PKI è obbligatorio",
    "urlFormat": "Formato dell’URL non valido",
    "login": "L’identificativo di accesso al server PKI è obbligatorio",
    "password": "La password del server PKI è obbligatoria",
    "templateName": "Nome obbligatorio",
    "templateFormat": "Nome del template non valido",
    "pemFileSize": "La dimensione del file .PEM deve essere inferiore a 1 MB",
    "pemFileMandatory": "Il file deve essere un .PEM",
    "rootCa": "La rootCA è obbligatoria",
    "pemFileEmpty": "Il file .PEM non deve essere vuoto",
    "pemFileInvalid": "Il file .PEM non è valido"
  },
  "testConnection": {
    "messageSuccess": "La configurazione del server PKI è valida",
    "messageFailTitle": "Errore test di connessione",
    "messageFailConnectivity": "URL non valido",
    "messageFailAuthentication": "Coppia identificativo/password non valida",
    "messageFailRootca": "RootCA non valida",
    "tooltip": "Testa la connessione",
    "ok": "OK",
    "ko": "KO"
  },
  "button": {
    "viewCertificate": "Vedere i certificati"
  },
  "filters": {
    "searchByAlias": "Cerca per alias"
  },
  "noPki": "Nessun PKI trovato",
  "alias": "Alias",
  "type": {
    "label": "Tipo",
    "EST": "EST",
    "MICROSOFT": "Microsoft"
  },
  "url": "URL",
  "delete": {
    "title": "Elimina la connessione PKI",
    "message": "Confermi l'eliminazione di questa connessione PKI? Non sarà più possibile eseguire operazioni con questo PKI."
  },
  "form": {
    "title": {
      "create": "Crea una nuova connessione",
      "update": "Edizione connessione"
    },
    "warning": {
      "title": "Certificato PKI richiesto",
      "message": "Un certificato PKI dedicato con i tag PKI appropriati deve essere presente nel keystore"
    },
    "connectionSettings": {
      "title": "Impostazioni di connessione"
    },
    "login": {
      "label": "Nome utente"
    },
    "password": {
      "label": "Password"
    },
    "specificConfiguration": {
      "templateName": {
        "label": "Nome modello"
      },
      "retryAfter": {
        "label": "Durata intervallo tra tentativi"
      },
      "label": {
        "urlLabel": "Etichetta"
      }
    },
    "validate": {
      "create": "Aggiungi una connessione",
      "update": "Salva"
    },
    "cancel": {
      "confirm": {
        "title": {
          "create": "Creazione connessione PKI",
          "update": "Aggiornamento connessione PKI"
        },
        "message": {
          "create": "Vuoi eliminare tutte le informazioni di ingresso e abbandonare la creazione della connessione PKI? Tutte le informazioni andranno perse.",
          "update": "Vuoi eliminare tutte le informazioni di ingresso e abbandonare l'aggiornamento della connessione PKI? Tutte le informazioni andranno perse."
        }
      }
    },
    "validation": {
      "alias": {
        "required": "L'alias è obbligatorio",
        "max": "L'alias deve contenere al massimo 50 caratteri"
      },
      "url": {
        "required": "L'URL è obbligatorio",
        "max": "L'URL deve contenere al massimo 120 caratteri"
      },
      "type": {
        "required": "Il tipo è obbligatorio"
      },
      "login": {
        "required": "Il nome utente è obbligatorio"
      },
      "password": {
        "required": "La password è obbligatoria"
      },
      "templateName": {
        "required": "Il nome del modello è obbligatorio"
      },
      "intervalTime": {
        "required": "La durata dell'intervallo tra tentativi è obbligatorio",
        "min": "Il valore non può essere inferiore a 60"
      },
      "urlLabel": {
        "max": "L'etichetta deve contenere al massimo 100 caratteri",
        "format": "L’etichetta deve contenere solo caratteri alfanumerici, trattini e trattini bassi"
      }
    },
    "trustChainsAliases": {
      "label": "Certificato truststore associato",
      "selectAll": "Seleziona tutti i certificati",
      "selectSearchPlaceholder": "Cerca per alias",
      "selectNoResult": "Nessun certificato trovato",
      "help": "Il PKI verrà utilizzato come proxy per rinnovare i certificati degli apparati identificati dal certificato truststore, gestendo anche il rinnovo dei certificati di keystore."
    },
    "testConnection": {
      "button": "Testa la connessione",
      "noPassword": "Si prega di inserire una password per testare la connessione"
    }
  }
}
